import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LiliButton } from '@lili/lili-frontend-common';
import { GENERAL_STYLE, FORGOT_EMAIL_PAGE_DATA } from '../constants';
import LoginCard from '../../../components/LoginCard';
import Heading from '../../../../../generic-components/Heading';
import { LoginHelpNavBar } from '../LoginHelpNavBar';
import { VIEWS_MAP } from '../../../../../router/constants';
import { useRecoverEmail } from './hooks/useRecoverEmail';
import { PhoneInput } from '../../../../../generic-components/PhoneInput/PhoneInput';
import { ForgotEmailErrorModal } from './ForgotEmailErrorModal';
import { Layout } from '../../../../../components/Layout/Layout';

interface IProps {
  onSubmit: (phone: string) => void;
}
const ForgotEmail = ({ onSubmit }: IProps) => {
  const { t } = useTranslation();
  const [showError, setShowError] = useState<boolean>(false);
  const [phoneInput, setPhoneInput] = useState<string>('');
  const [isPhoneValid, setIsPhoneValid] = useState<boolean>(false);

  const navigate = useNavigate();
  const { mutateAsync: mutateRecoverEmail, isLoading } = useRecoverEmail(
    () => {
      setShowError(true);
    },
  );

  const triggerRecoverEmail = () => {
    setShowError(false);
    const regex = /[ ()-]/g;
    const cleanPhone = phoneInput.replace(regex, '');
    mutateRecoverEmail({ phoneNumber: cleanPhone })
      .then(() => {
        onSubmit(phoneInput);
      });
  };
  const validatePhoneNumber = (phoneNumber: string) => {
    const phoneRegex = /^\+?[0-9]{1,3}\s?[0-9]{9,14}$/;
    return phoneRegex.test(phoneNumber);
  };

  const onInputChange = (value: string) => {
    const regex = /[ ()-]/g;
    let cleanPhone = value.replace(regex, '');
    const isValid = validatePhoneNumber(cleanPhone);
    if (!cleanPhone.includes('+')) { cleanPhone = `+1${cleanPhone}`; }

    setIsPhoneValid(isValid);
    setPhoneInput(cleanPhone);
  };
  const errorModal = (
    showError && (
    <ForgotEmailErrorModal
      onMainActionClick={triggerRecoverEmail}
      onSecondaryActionClick={() => setShowError(false)}
      onClose={() => setShowError(false)}
    />
    )
  );

  const heading = (
    <Heading
      title={t(FORGOT_EMAIL_PAGE_DATA.HEADING_TITLE)}
      className={`${GENERAL_STYLE.HEADING.CLASS_NAME} mb-[36px]`}
    />
  );

  const mainButton = (
    <LiliButton
      id='mainButton'
      title={t(FORGOT_EMAIL_PAGE_DATA.CONTINUE_BUTTON_TITLE)}
      className={`${GENERAL_STYLE.MAIN_BUTTON.CLASS_NAME}`}
      onClick={triggerRecoverEmail}
      isLoading={isLoading}
      disabled={!isPhoneValid}
    />
  );
  return (
    <Layout shouldHideProfile shouldHideChatBot wrapperClassName='pt-[78px] pl-[72px] ml-[100px] pc-md:ml-[256px]'>
      <LoginHelpNavBar
        onBackClick={() => navigate(`/${VIEWS_MAP.RECOVERY}`)}
        onCloseClick={() => navigate(`/${VIEWS_MAP.LOGIN}`)}
      />

      {errorModal}

      <LoginCard className={GENERAL_STYLE.LOGIN_CARD.CLASS_NAME}>
        <div className='flex flex-col justify-between h-full'>

          <div className='mb-[125px]'>
            {heading}
            <PhoneInput onValueChange={onInputChange} />
          </div>
          {mainButton}
        </div>
      </LoginCard>
    </Layout>

  );
};

export default ForgotEmail;
